/**
 * Daikin Web — Backend API endpoint constants.
 * Mirrors the mobile app's API_ENDPOINTS pattern.
 */
export const API_ENDPOINTS = {
  POSTS: {
    FEED: "/api/Post/feed",
    DETAIL: (id) => `/api/Post/${id}`,
    CREATE: "/api/Post",
    DELETE: (id) => `/api/Post/${id}`,
    REACTION: (id) => `/api/Post/${id}/reactions`,
    REMOVE_REACTION: (id) => `/api/Post/${id}/reactions`,
    REACTIONS_LIST: (id) => `/api/Post/${id}/reactions`,
    COMMENTS: (postId) => `/api/Post/${postId}/comments`,
    ADD_COMMENT: (postId) => `/api/Post/${postId}/comments`,
    COMMENT_REACTION: (postId, commentId) =>
      `/api/Post/${postId}/comments/${commentId}/reactions`,
    PIN: (id) => `/api/Post/${id}/pin`,
    REPORT: (id) => `/api/Post/${id}/report`,
    POLL_VOTE: (postId) => `/api/Post/${postId}/poll/vote`,
  },
  STORIES: {
    CIRCLES: "/api/Story/circles",
    USER_STORIES: (userId) => `/api/Story/user/${userId}`,
    CREATE: "/api/Story",
    DELETE: (id) => `/api/Story/${id}`,
    MARK_VIEWED: (id) => `/api/Story/${id}/view`,
    SETTINGS: "/api/Story/settings",
    PIN: (id) => `/api/Story/${id}/pin`,
    VIEWERS: (id) => `/api/Story/${id}/viewers`,
    DETAIL: (id) => `/api/Story/${id}`,
  },
  CONTENT_CARDS: {
    LIST: "/api/ContentCard",
  },
  NOTIFICATIONS: {
    LIST: "/api/Notification",
    UNREAD_COUNT: "/api/Notification/unread-count",
    MARK_READ: (id) => `/api/Notification/${id}/read`,
    MARK_ALL_READ: "/api/Notification/read-all",
    DELETE: (id) => `/api/Notification/${id}`,
  },
  EVENTS: {
    COMPANY_CALENDAR: "/api/Events/company-calendar",
  },
  PAYROLL: {
    VERIFY: "/api/Payroll/verify",
    VERIFY_CODE: "/api/Payroll/verify-code",
    GET_PAYSLIP: "/api/Payroll/get-payslip",
  },
  SUGGESTIONS: {
    QUESTIONS: "/api/Suggestion/questions",
    ANSWERS: "/api/Suggestion/answers",
  },
  DISCOUNT_COUPONS: {
    BRANDS: "/api/DiscountCoupon/brands",
    MY_COUPONS: "/api/DiscountCoupon/my-coupons",
    GENERATE: "/api/DiscountCoupon/generate",
    REMAINING_COUNTS: "/api/DiscountCoupon/remaining-counts",
    NOTICES: "/api/DiscountCoupon/notices",
    ELIGIBILITY: "/api/DiscountCoupon/eligibility",
  },
  USER: {
    PROFILE: "/api/User/profile",
    SETTINGS: "/api/User/settings",
    DEFAULT_AFFILIATE: "/api/User/default-affiliate",
  },
  SIDEBAR: {
    DRAWER_NAV: "/api/SidebarMenu/drawer-nav",
    SOCIAL_LINKS: "/api/SidebarMenu/social-links",
  },
  POLLS: {
    HAS_ACTIVE: "/api/Poll/has-active",
  },
  UPLOAD: {
    IMAGE: "/api/Upload/image",
  },
};

export const PAGINATION = {
  POSTS_PER_PAGE: 10,
  COMMENTS_PER_PAGE: 20,
  NOTIFICATIONS_PER_PAGE: 20,
};
